export default {
  data: function () {
    return {
      usernameRules: [
        v => !!v || this.$t('user.create.error.empty-name'),
        v => v.length > 2 || this.$t('user.create.error.min-length-3'),
        v => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('user.create.error.first-letter')
      ],
      emailRules: [ v => /^\S+@\S+\.[a-z]{2,}$/.test(v) || this.$t('user.create.error.incorrect-email') ]
    }
  }
}
